import { gql } from '@apollo/client';

export const GET_STATEMENTS_UI_STATE = gql`
    query getStatementsUiState {
        uiState @client {
            statements {
                showUploadHasStarted
                statementId
                unviewedStatements
            }
        }
    }
`;
